<template>
  <div class="indexContainer" :class="{ mini: $root.$data.miniEnv }">
    <Header
      v-if="!$root.$data.miniEnv"
      :beforeExec="$root.isApp ? goHome : () => { }"
      :back="true"
      bgc="#fff"
      titleName="好友助力"
    ></Header>
    <div class="invite_help_container">
      <img
        class="bg"
        src="https://iqh-zt-pord-cdn.iqihang.com/ark-words-mini/course/share-bg.png"
        alt
      />
      <div class="content">
        <div class="msg">{{ statusInfo.msg }}</div>
        <div class="btn" @click="handleClick">{{ !statusInfo.status ? '帮他助力' : '去学习' }}</div>
      </div>
    </div>

    <div class="dialog" v-if="showMask">
      <div class="content">
        <div class="title">
          <img src="https://iqh-zt-pord-cdn.iqihang.com/ark-words-mini/course/share-title.png" mode />
        </div>
        <div class="msg">已成功助力！</div>
        <div class="msg1">快来和我一起参加打卡挑战吧～</div>
        <div class="btn" @click="goMock">去看看</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { OSSURL } from '@/utils/common';
import Header from '@/components/header/CommonTitle.vue';
import { givePrizeHelpStatus, givePrizeHelpAdd, getActiveDetail } from '@/api/check/index';
import wx from 'weixin-js-sdk';
import { whatEev } from '@/utils/tools';
import { miniSchemeUrl } from '@/utils/common';

export default {
  components: { Header },
  name: 'examInvitationHelp',
  computed: {
    ...mapState(['userInfo']),
  },
  data() {
    return {
      isLogin: false,
      statusInfo: {
        status: 0,
        msg: '小伙伴，我正在启航“坚持打卡赢学习礼包”热门活动，请点击按钮帮我助力！',
      },
      showMask: false,
      activityName: '',
    };
  },
  created() {},
  mounted() {
    window['iqhApp2jsBridge.triggerSC'] = {};
    setTimeout(() => {
      // 获取登录状态
      window['iqhApp2jsBridge.triggerSC'].getLogin = this.getLogin;
    }, 100);
    this.$root.getUserInfo();
    getActiveDetail({ activityId: this.$route.query.p, isPreview: 0 }).then(res => {
      const { data = {}, code } = res;

      const { activityName } = data;
      this.activityName = activityName;
      if (this.statusInfo.status == 0) {
        this.statusInfo = {
          ...this.statusInfo,
          msg: `小伙伴，我正在启航“${activityName}”热门活动，请点击按钮帮我助力！`,
        };
      }
    });
  },
  methods: {
    getLogin(APPSESSION) {
      const ua = navigator.userAgent.toLowerCase();
      const cookieToken = /ohos/.test(ua) ? APPSESSION.token : APPSESSION;
      if ((window?.navigator?.userAgent || '').includes('iqihang')) {
        window.localStorage.setItem('accessToken', cookieToken || '');
        this.getLoginAfter();
      }
    },
    async getLoginAfter() {
      await this.$root.getUserInfo();
    },
    handleClick() {
      if (!this.isLogin) {
        const path = `/checkHelp/${window.location.search}`;
        console.log('path', path);
        this.openLogin(path);
      }
      if (!this.statusInfo.status) {
        this.$toast.loading({
          forbidClick: true,
        });
        givePrizeHelpAdd(this.$route.query.p, this.$route.query.u)
          .then(res => {
            if (res.code === 0) {
              this.showMask = true;
            }
          })
          .finally(() => {
            this.$toast.clear();
          });
      } else {
        this.goMock();
      }
    },
    openLogin(path) {
      const address = `${window.location.origin}/checkHelp`;
      if (this.$root.isApp) {
        this.$sendToApp(
          'newLogin',
          {
            clientType: 40,
            address,
            extraInfo: {
              userSource_var: '打卡活动',
              landingPage_var: '/checkHelp',
            },
          },
          true,
        );
      } else {
        const param = { redirect: path, ...this.$route.query };
        console.log(2222, param);
        const routeUrl = this.$router.resolve({
          path: '/ark/registrationLogin',
          query: param,
        });
        window.history.replaceState(null, null, routeUrl.resolved.fullPath);
        window.location.reload();
      }
    },
    goMock() {
      if (whatEev() === 'miniprogram') {
        wx.miniProgram.redirectTo({
          url: '/pages/home/home',
        });
      } else if (this.$root.$data.isApp) {
        this.$sendToApp('goWechatProject', {
          userName: 'gh_5fb96ed24012',
          path: '/pages/home/home',
        });
      } else {
        this.getSchemeUrl();
      }
    },
    async getSchemeUrl() {
      const schemeLink = await miniSchemeUrl('wxdb89cfa2bb60f779', '/pages/home/home');
      window.location.href = schemeLink;
    },
  },
  watch: {
    userInfo: {
      handler(newVal, oldVal) {
        console.log('userInfo', newVal.id, oldVal.id);
        if (newVal.id) {
          this.isLogin = true;
          console.log(11111, newVal);
          givePrizeHelpStatus(this.$route.query.p, this.$route.query.u).then(res => {
            console.log('res111', res);
            let status = res.data;
            if (newVal.id == this.$route.query.u) {
              status = 4;
            }
            const map = {
              0: `小伙伴，我正在启航“${this.activityName}”热门活动，请点击按钮帮我助力！`,
              1: '你已经帮好友助力过啦，不能再助力了，快来和我一起学习吧~',
              2: '你已经是老用户啦，不能再助力了，快来和我一起学习吧~',
              3: '被助力用户次数已达上限',
              4: '不能帮助自己助力啦！',
            };

            this.statusInfo = {
              status,
              msg: map[status],
            };
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
$width: 100%;
$height: 100%;
$borderRadius: 14px;
$infoPaddingBottom: 18px;
$commonColor: '#333';
$pageBgColor: #f8f8f8;
$baseBgColor: #fff;

.indexContainer.mini {
  padding-top: 0px;
}

.indexContainer {
  width: $width;
  background-color: #f7f8fc;
  position: relative;
  padding: 80px 0px 0 0px;
  height: 100vh;
  overflow-y: scroll;

  .headerTitle {
    margin: 0 auto;
    color: #000;
    font-size: 36px;
  }

  .invite_help_container {
    width: 100%;
    position: relative;
    overflow: hidden;
    background: #f7f8fc;
    min-height: 95vh;

    .bg {
      display: block;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }

    .msg {
      width: 529px;
      font-weight: 400;
      font-size: 29px;
      color: #333333;
      line-height: 47px;
      text-align: center;

      position: absolute;
      top: 627px;
      left: 50%;
      transform: translate(-50%, 0);
    }

    .btn {
      width: 391px;
      height: 91px;
      background-image: url('https://iqh-zt-pord-cdn.iqihang.com/ark-words-mini/course/share-btn.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;

      position: absolute;
      top: 772px;
      left: 50%;
      transform: translate(-50%, 0);

      font-weight: 500;
      font-size: 29px;
      color: #ffffff;
      line-height: 40px;
      line-height: 91px;
      text-align: center;
    }
  }

  .dialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);

    .content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 634px;
      height: 583px;
      background: #ffffff;
      border-radius: 36px;
    }

    .content .title {
      width: 100%;
      height: 297px;
      background-image: url('https://iqh-zt-pord-cdn.iqihang.com/ark-words-mini/course/share-title-bg.png');
      background-size: 100%;
      background-repeat: no-repeat;
      text-align: center;
      padding-top: 80px;
    }

    .content .title img {
      width: 330px;
      height: 217px;
    }

    .content .msg {
      font-weight: 500;
      font-size: 29px;
      color: #333333;
      padding: 36px 0 11px 0;
      text-align: center;
    }

    .content .msg1 {
      font-weight: 400;
      font-size: 25px;
      color: #333333;
      padding: 0px 0 33px 0;
      text-align: center;
    }

    .content .btn {
      width: 330px;
      height: 65px;
      background: #ff7f41;
      border-radius: 33px;
      font-weight: 400;
      font-size: 25px;
      color: #ffffff;
      line-height: 65px;
      text-align: center;
      margin: 0 auto;
    }
  }
}
</style>
<style>
.app {
  height: 100% !important;
}
</style>